import { render, staticRenderFns } from "./RatingKpis.vue?vue&type=template&id=7e53f8c5&"
import script from "./RatingKpis.vue?vue&type=script&lang=ts&"
export * from "./RatingKpis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports